<template>
  <ul class="product-grid">
    <template v-for="(item, index) in items" :key="item.id">
      <NarrativeProductCard
        :product="item"
        :allow-add-to-cart="allowAddToCart"
        :quantity-limit="quantityLimit"
        :pdp-link="pdpLink"
        :add-button-text="addButtonText"
        :partner-id="partnerId"
        allow-deeper-discount
        allow-category-label
        v-bind="$attrs"
      />
      <client-only>
        <li
          v-if="
            enableQesSection &&
            index === intersectIndex &&
            !$auth?.loggedIn &&
            !signedUp &&
            showQes
          "
          class="email-signup-li"
        >
          <div class="plp-qes-container home-email-modal">
            <ThankYou v-if="registerSuccess" />
            <QuickEmailSignup
              v-if="!registerSuccess"
              :auto-focus="false"
              @closed="showQes = false"
              @register-success="registerSuccess = true"
            />
          </div>
        </li>
      </client-only>
    </template>
  </ul>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { useNuxtApp, useCookie } from '#app'

const { $auth } = useNuxtApp()

const NarrativeProductCard = defineAsyncComponent(
  () => import('./Card/NarrativeProductCard'),
)
const ThankYou = defineAsyncComponent(
  () => import('@/components/Index/ThankYou'),
)
const QuickEmailSignup = defineAsyncComponent(
  () => import('@/components/Index/QuickEmailSignup'),
)

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  partnerId: {
    type: Number,
    default: null,
  },
  enableQesSection: {
    type: Boolean,
    default: false,
  },
  allowAddToCart: {
    type: Boolean,
    default: true,
  },
  pdpLink: {
    type: Boolean,
    default: true,
  },
  quantityLimit: {
    type: Number,
    default: null,
  },
  addButtonText: {
    type: String,
    default: 'Add to Cart',
  },
  allowLoadingIcon: {
    type: Boolean,
    default: true,
  },
})

const intersectIndex = ref(-1)
const showQes = ref(true)
const registerSuccess = ref(false)

const signedUp = computed(() => {
  const cookie = useCookie('new-quicksignup')
  return cookie.value
})

const calculateIntersectIndex = () => {
  const gridElement = document.querySelector('.product-grid')
  if (gridElement) {
    const gridTemplateColumns = window
      .getComputedStyle(gridElement)
      .getPropertyValue('grid-template-columns')
    const spaces = (gridTemplateColumns.split(' ') || []).length
    const columnCount = spaces || 1

    if (columnCount === 0 || columnCount === 1 || columnCount === 2) {
      intersectIndex.value = 3
    } else {
      intersectIndex.value = 5
    }
  } else {
    intersectIndex.value = 3
  }
}

onMounted(() => {
  calculateIntersectIndex()
  window.addEventListener('resize', calculateIntersectIndex)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', calculateIntersectIndex)
})
</script>

<style>
.modal-container.home-email-modal,
.plp-qes-container.home-email-modal {
  max-width: none !important;
}
</style>
